import React, { useEffect, useState } from "react";

function Semester({ value, onChange }) {
  // Define the dropdown options
  const dropdownOptions = {
    Semester: [
      { label: "NONE", value: "" },
      { label: "SEMESTER I", value: "Sem. I" },
      { label: "SEMESTER II", value: "Sem. II" },
    ],
    Trimester: [
      { label: "TRIMESTER I", value: "Tri. I" },
      { label: "TRIMESTER II", value: "Tri. II" },
      { label: "TRIMESTER III", value: "Tri. III" },
    ], // No "NONE" in Trimester
  };

  // State to track available options
  const [options, setOptions] = useState(dropdownOptions[value.selection6]);

  // Effect to update options when selection6 changes
  useEffect(() => {
    setOptions(dropdownOptions[value.selection6] || dropdownOptions.Semester);

    // Only reset selection7 if it is not already part of the new selection6 options
    if (!dropdownOptions[value.selection6].some(option => option.value === value.selection7)) {
      onChange({
        target: { name: "selection7", value: dropdownOptions[value.selection6][0].value },
      });
    }
  }, [value.selection6]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        maxWidth: "100%",
      }}
    >
      <label
        htmlFor="selection6"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        {/* First dropdown for selecting Semester/Trimester */}
       <select
  name="selection6"
  value={value.selection6}
  onChange={onChange}
  style={{
    flex: "1",
    minWidth: "50px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #64b5f6", // Blue border
    fontSize: "1rem",
    background: "linear-gradient(135deg, #e3f2fd, #90caf9)", // Blue gradient
    color: "#1565c0", // Blue font color

    // ❌ Removed to show default system arrow
    // appearance: "none",
    // WebkitAppearance: "none",
    // MozAppearance: "none",

    boxShadow: "0px 4px 8px rgba(100, 181, 246, 0.4)", // Light blue shadow
    transition: "background-color 0.3s ease",
    cursor: "pointer",
  }}
>
  <option value="Semester">Semester</option>
  <option value="Trimester">Trimester</option>
</select>


        {/* Second dropdown for displaying options based on the first dropdown */}
        <select
          name="selection7"
          value={value.selection7}
          onChange={onChange}
          style={{
            flex: "2",
            minWidth: "200px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            boxSizing: "border-box",
          }}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default Semester;
